<template>
      <div class="ready-to-launch">
        <h2>Quick Review</h2>
        <div class="row">
          <div class="col-md-8">
            <div class="campaign-overview">
              <h3>Campaign Overview</h3>
              <div class="campaign-overview-list">
                <div class="row">
                  <div class="col-md-10 offset-md-1">
                    <div class="row">
                      <div class="col-md-6">
                        <h4>Campaign Name</h4>
                        <h6>{{ getCampaignDetail.campaign_name }}</h6>
                        <h4>Num of Activities</h4>
                        <h6>{{ getCampaignDetail.total_activity_count }}</h6>
                        <h4>Budget</h4>
                        <h6>{{ getCampaignDetail.campaign_budget }}</h6>
                        <h4>Incentive Type</h4>
                        <h6>{{ getCampaignDetail.incentive_type }}</h6>
                        <h4>Start-Date - <span>{{ getCampaignDetail.start_date }}</span></h4>
                        <h4>End-Date - <span>{{ getCampaignDetail.end_date }}</span></h4>
                        <h4>Unlock Code</h4>
                        <h6>{{ getCampaignDetail.unlock_code }}</h6>

                      </div>
                      <div class="col-md-6">
                        <h4>Geo-Location Type</h4>
                        <h6>{{ getCampaignDetail.geo_location_type }}</h6>
                        <h4>Single User Limit</h4>
                        <h6>{{ getCampaignDetail.single_user_limit }}</h6>
                        <h4>Incentives</h4>
                        <h6>{{ getCampaignDetail.coupon }}</h6>
                        <h4>Package of Benefit</h4>
                        <h6>{{ getCampaignDetail.package }}</h6>
                        <h4>Buy Me Activity</h4>
                        <h6>Not available for freemium</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="action_button_box" v-if="getCampaignDetail.status == 'Awaiting Approval' ">
              <button class="Reject_button" @click="rejectCamp(getCampaignDetail.pickl_id)">Reject</button>
              <button class="Approve_button" @click="approveCamp()">Approve</button>
            </div>
          </div>
          <div class="col-md-4">
          <div :class="['preview NewPrevAct', { 'scrolled-fix': isScrolled }]" v-if="showProductPreview">
          <div class="store_brand">
            <img :src="getStoreDetail.img" class="left_brand" />
            <h6>{{ brandInfo.name }}</h6>
            <img :src="brandInfo.logo" class="right_brand" />
          </div>
          <div class="mapBox">
              <h5>"{{ getStoreDetail.name }}"</h5>
              <h6>Category: {{ previewProductDetail.name }}</h6>
              <ChartTemp :codes="selectedStatesCodes || {}" :retailerImage="getStoreDetail.img"/>
          </div>
          <div class="brand_intro">
            <div class="brand_desc">
              <div class="brand_header" style="float: left;">
                <img :src="previewProductDetail.img" />
                <h6 style="text-align: left;color: #000; font-size: 15px;font-weight: 500;">{{ previewProductDetail.name }}</h6>
                <p style="text-align: left;">{{ previewProductDetail.description }}</p>
              </div>
              <p style="font-weight: 500; font-size: 14px;color: #000;text-align: left; float: left;width: 100%; margin-bottom: 7px;">{{ mixTasks.length ? 'Activities' : 'Image Requirements' }}</p>
              <ul style="max-height: 210px; overflow: hidden;padding-left: 6px; list-style: none;">
                <li v-for="(task, index) in previewTasks" :key="task.id || index" style="font-size: 14px;margin-bottom: 6px;">{{ getTaskDisplayName(task) }}</li>
              </ul>
            </div>
          </div>
        </div>
          <!-- <div class="preview" v-if="getCampaignDetail.geo_location_type == 'any-physical-location'">
            <div class="brand_head">
              <img src="/img/Arrow_2.png" />
              {{ getStoreDetail.brandName }}<br />{{ getStoreDetail.name }}
            </div>
            <h6></h6>
            <div class="store_brand">
              <img :src="getStoreDetail.img" class="left_brand" style="width: 35px;" />
              <h6>Do it at any location</h6>
              <img :src="getStoreDetail.brandImg" class="right_brand" />
            </div>
            <div class="brand_intro">
              <div class="brand_desc">
                <div class="brand_header">
                  <img :src="getProductDetail.img" />
                  <h6 style="text-align: left;">{{ getProductDetail.name }}</h6>
                  <p style="background: transparent; color: #000;">{{ getProductDetail.description }}</p>
                </div>
                <ul style="max-height: 130px; overflow: hidden; padding-left: 0; margin-top: 15px;">
                  <li v-for="task in getTasks" :key="task.name">{{ task.name }}</li>
                </ul>
                <img src="/img/start_pickl.png" class="start_pickl" />
              </div>
            </div>
            <img src="/img/phone_bottom.png" class="task_bar" />
          </div>-->
          <div :class="['preview cr_page newPrev', { 'scrolled-fix': isScrolled }]" v-else-if="showVideoPreview">
            <div class="logoHeadBox">
              <div class="newPrevLogo"><img :src="brandInfo.logo" style="max-width: 100%; border-radius: 50%;" /></div>
              <div class="newPrevHead"> {{ brandInfo.name }} </div>
            </div>
            <div class="yourVideo">
              <h5 v-if="!previewVideoId">Your Video</h5>
              <span v-else><iframe width="100%"
                  height="120px"
                  :src="'https://www.youtube.com/embed/'+previewVideoId"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe
              ></span>
            </div>
            <!--<div class="mediaName">
                <h4>{{ previewMediaTitle }}</h4>
                <h6>{{ previewMediaIntro }}</h6>
            </div> -->
            <div class="mediaDesc">
                <h4>Description</h4>
                <p style="text-align: left;">{{ previewMediaDescription }}</p>
            </div>
            <div class="mixTaskList" v-if="mixTasks.length">
              <h4>Activities</h4>
              <ul>
                <li v-for="(activity, index) in mixTasks" :key="activity.id || index">{{ getTaskDisplayName(activity) }}</li>
              </ul>
            </div>
          </div>

          <!-- <div class="preview cr_page" v-else>
            <div class="brand_head">
              <img src="/img/Arrow_2.png" />
              {{ getStoreDetail.brandName }}
            </div>
            <div class="media_name">
              {{ media.title }}
            </div>
            <div class="your_video">
              <span
                ><iframe
                  width="100%"
                  height="120px"
                  :src="'https://www.youtube.com/embed/'+videoId"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe></span>
            </div>
            <div class="brand_intro" style="top: 266px !important;">
              <div class="brand_desc">
                <div class="brand_header">
                  <img :src="brandInfo.logo" />
                  <h6>{{ brandInfo.name }}</h6>
                  <p>Introduction</p>
                </div>
                <p style="font-size: 13px; padding: 12px; text-align: left;">
                  {{ media.description }}
                </p>
              </div>
            </div>
            <img src="/img/phone_bottom.png" class="task_bar" />
          </div> -->
          </div>
        </div>
      </div>
</template>
<script>
import ChartTemp from '@/components/common/ChartDiv.vue'
export default {
  name: 'ReadyToLaunch',
  components: {
    ChartTemp
  },
  data () {
    return {
      getStoreDetail: {},
      getProductDetail: {},
      getCampaignDetail: {},
      media: {},
      getTasks: [],
      mixTasks: [],
      productActivity: null,
      photoActivity: null,
      mixProductDetail: null,
      watchActivity: null,
      watchVideoId: '',
      videoId: '',
      selectedStatesCodes: {},
      brandInfo: {
        name: '',
        logo: ''
      },
      brandId: this.$store.state.userData.brandId
    }
  },
  computed: {
    isMixCampaign () {
      return !!(this.mixTasks && this.mixTasks.length)
    },
    hasWatchActivity () {
      return !!this.watchActivity
    },
    hasProductActivity () {
      return !!this.productActivity
    },
    hasPhotoActivity () {
      return !!this.photoActivity
    },
    hasProductPhotos () {
      return this.hasProductActivity || this.hasPhotoActivity
    },
    showProductPreview () {
      if (this.isMixCampaign) {
        // Mix: no Watch/video → show map (product) preview
        return !this.hasWatchActivity
      }
      return this.getCampaignDetail.geo_location_type === 'any-physical-location'
    },
    showVideoPreview () {
      if (this.isMixCampaign) {
        // Mix: Watch/video → show youtube preview
        return this.hasWatchActivity
      }
      return this.getCampaignDetail.geo_location_type !== 'any-physical-location'
    },
    previewProductDetail () {
      if (this.mixProductDetail && (this.mixProductDetail.name || this.mixProductDetail.img)) {
        return this.mixProductDetail
      }
      return this.getProductDetail || {}
    },
    previewTasks () {
      if (this.mixTasks && this.mixTasks.length) {
        return this.mixTasks
      }
      return this.getTasks || []
    },
    previewVideoId () {
      return this.watchVideoId || this.videoId || ''
    },
    previewMediaTitle () {
      if (this.watchActivity) {
        return (this.watchActivity.link && this.watchActivity.link.title) ||
          this.watchActivity.activity_label ||
          'Watch'
      }
      return this.media.title || ''
    },
    previewMediaIntro () {
      if (this.watchActivity) {
        return (this.watchActivity.link && this.watchActivity.link.description) ||
          this.watchActivity.description ||
          ''
      }
      return this.media.brand_intro || ''
    },
    previewMediaDescription () {
      if (this.watchActivity) {
        return this.watchActivity.description ||
          (this.watchActivity.link && this.watchActivity.link.description) ||
          ''
      }
      return this.media.description || ''
    }
  },
  mounted () {
    // this.getBrandDetails();
    this.getStoreDetails()
    this.getProductTaskDetails()
    this.getMixCampaignActivityDetails()
    this.getCampaignView()
  },
  methods: {
    // getBrandDetails() {
    //   this.$store
    //     .dispatch("getBrandDetails", {
    //       brand_id: this.brandId,
    //     })
    //     .then((response) => {
    //       this.brandInfo = response.response.data;
    //       console.log(this.brandInfo);
    //     })
    //     .catch(() => {});
    // },
    getStoreDetails () {
      this.loadingStaff = true
      this.$http.get('plg/campaign-setting-store-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getStoreDetail = response.data
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getCampaignView () {
      this.$http.get('plg/get-campaign-reviewer-details/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getCampaignDetail = response.data
          if (this.getCampaignDetail.geo_location_type === 'any-user-location') {
            this.getMedia()
          }
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getProductTaskDetails () {
      this.$http.get('plg/campaign-product-task-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.getProductDetail = response.data.productDetails
          this.getTasks = response.data.tasks
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    getMixCampaignActivityDetails () {
      this.$http.get('plg/mix-campaign-activity-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          const data = response.data
          this.mixTasks = this.normalizeMixTasks(data)
          this.setWatchVideoFromActivities(this.mixTasks)
          this.setProductFromActivities(this.mixTasks)
          this.setPhotoFromActivities(this.mixTasks)
        }, (error) => {
          console.log(error)
          this.mixTasks = []
          this.watchActivity = null
          this.watchVideoId = ''
          this.productActivity = null
          this.photoActivity = null
          this.mixProductDetail = null
        }).catch((error) => {
          console.log(error)
          this.mixTasks = []
          this.watchActivity = null
          this.watchVideoId = ''
          this.productActivity = null
          this.photoActivity = null
          this.mixProductDetail = null
        })
    },
    normalizeMixTasks (data) {
      if (!data) return []
      let activities = []
      if (Array.isArray(data.activities)) {
        activities = data.activities
      } else if (Array.isArray(data)) {
        activities = data
      }
      return activities.slice().sort((a, b) => (a.order || 0) - (b.order || 0))
    },
    setWatchVideoFromActivities (activities) {
      const watch = (activities || []).find((activity) => activity.activity_type === 'watch')
      if (watch) {
        this.watchActivity = watch
        const websiteLink = watch.link && watch.link.website_link
        this.watchVideoId = websiteLink ? (this.extractVideoId(websiteLink) || '') : ''
      } else {
        this.watchActivity = null
        this.watchVideoId = ''
      }
    },
    setProductFromActivities (activities) {
      const product = (activities || []).find((activity) => activity.activity_type === 'product')
      this.productActivity = product || null
      if (product && Array.isArray(product.products) && product.products.length) {
        const firstProduct = product.products[0]
        this.mixProductDetail = {
          name: firstProduct.name || product.activity_label || 'Product Activity',
          description: firstProduct.description || product.description || '',
          img: firstProduct.img || ''
        }
      } else if (product && Array.isArray(product.tasks) && product.tasks.length) {
        const firstTask = product.tasks[0]
        this.mixProductDetail = {
          name: product.activity_label || 'Product Activity',
          description: product.description || '',
          img: firstTask.img || ''
        }
      } else if (product) {
        this.mixProductDetail = {
          name: product.activity_label || 'Product Activity',
          description: product.description || '',
          img: ''
        }
      } else {
        this.mixProductDetail = null
      }
    },
    setPhotoFromActivities (activities) {
      this.photoActivity = (activities || []).find((activity) => activity.activity_type === 'photo') || null
      if (!this.productActivity && this.photoActivity) {
        const firstTask = (this.photoActivity.tasks || [])[0]
        this.mixProductDetail = {
          name: this.photoActivity.activity_label || 'Photo Activity',
          description: this.photoActivity.description || '',
          img: firstTask && firstTask.img ? firstTask.img : ''
        }
      }
    },
    getTaskDisplayName (task) {
      if (!task) return ''
      if (typeof task === 'string') return task
      return task.activity_label || task.name || task.task_name || task.label || task.title || ''
    },
    getMedia () {
      this.$http.get('plg/campaign-media-detail/' + this.$route.params.CampaignId)
        .then((response) => {
          console.log(response.data)
          this.media = response.data
          // Prefer watch activity youtube link when present
          if (!this.watchVideoId) {
            this.videoId = this.extractVideoId(this.media.video_url)
          }
          console.log(this.videoId)
        }, (error) => {
          console.log(error)
        }).catch((error) => {
          this.$notify(
            { type: 'error', text: error.message }
          )
        })
    },
    extractVideoId (url) {
      if (!url) return null
      const regex = /(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?|shorts)\/|.*[?&]v=)|youtu\.be\/)([\w-]{11})/
      const match = url.match(regex)
      return match ? match[1] : null
    },
    approveCamp () {
      const campId = this.isMixCampaign
        ? (this.$route.params.CampaignId || this.getCampaignDetail.id || this.getCampaignDetail.pickl_id)
        : this.getCampaignDetail.pickl_id
      let data = { campId: campId }
      const approveUrl = this.isMixCampaign ? 'plg/approve-mix-campaigns' : 'plg/approve-campaigns'
      this.$http
        .post(approveUrl, data)
        .then((response) => {
          this.$notify({ type: 'success', text: 'Campaign has been successfully approved and is ready to launch!' })
          this.busy = false
          this.getCampaignView()
        })
        .catch((error) => {
          this.$notify({ type: 'error', text: (error.body && error.body.message) || error.message || 'Failed to approve campaign' })
        })
    },
    rejectCamp (campId) {
      let data = { campId: campId }
      this.$http
        .post('plg/reject-campaigns', data)
        .then((response) => {
          this.$notify({ type: 'success', text: 'Campaign has been successfully rejected' })
          this.busy = false
          this.getCampaignView()
        })
        .catch((error) => {
          this.$notify({ type: 'error', text: (error.body && error.body.message) || error.message || 'Failed to reject campaign' })
        })
    }
  }
}
</script>
<style>
.ready-to-launch h2 {
    text-align: center;
    color: #782B55;
    margin-top: 15px;
    margin-bottom: 20px;
    font-weight: 700;
}
.ready-to-launch p{
    text-align: center;
    font-size: 17px;
    margin-bottom: 30px;
}
.campaign-overview {
    background: #F9F9F9;
    border: 1px solid #000;
    padding: 15px 30px;
    border-radius: 8px;
}
.Reject_button{
    background-color: #D62400;
}
.Approve_button{
    background-color: #55C287;
}
.campaign-overview h3{
    color: #000;
    font-size: 24px;
}
.action_button_box {
    text-align: center;
    padding-top: 25px;
}
.action_button_box button {
    padding: 5px 50px;
    margin: 0px 10px;
    font-weight: 600;
    font-size: 16px;
    border: 0px;
    border-radius: 9px;
    color: #fff;
}
.ready-to-launch .preview{
    background: url("/../img/Home_Screen_Widgets.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 620px;
    max-width: 300px;
    margin: 0 auto;
    position: relative;
}
.ready-to-launch .brand_head {
    text-align: center;
    margin-top: 50px;
    position: absolute;
    width: 82%;
    margin-left: 9%;
    padding: 7px;
    color: #000;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
}
.ready-to-launch .brand_head img {
    position: absolute;
    left: 12px;
    top: 19px;
    width: 8px;
}
/* .ready-to-launch .store_brand {
    position: absolute;
    width: 82%;
    left: 9%;
    top: 98px;
    border-top: 1px solid #DEF2E6;
    padding-top: 3px;
} */
/* .ready-to-launch .brand_intro {
    height: 280px;
    background: #FBF0E8;
    width: 82%;
    position: absolute;
    left: 9%;
    top: 145px;
} */
.ready-to-launch .brand_header {
    border-bottom: 1px solid #12DA6D;
    width: 90%;
    margin-left: 5%;
    padding: 5px 5px;
}
.ready-to-launch .brand_header img {
    width: 52px;
    float: left;
    margin-right: 5px;
}
.ready-to-launch .brand_header h6 {
    font-family: "Roboto", sans-serif;
    color: #782B55;
    font-size: 14px;
    margin-left: 5px;
    margin-top: 3px;
    margin-bottom: 5px;
}
/* .ready-to-launch .brand_header p {
    font-size: 12px;
    margin-left: 0px;
    display: inline;
    background: #F1605C;
    color: #fff;
    padding: 5px 8px;
    border-radius: 20px;
} */
.ready-to-launch .task_bar {
    width: 82%;
    position: absolute;
    bottom: 40px;
    left: 9%;
}
.ready-to-launch .start_pickl {
    position: absolute;
    bottom: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    max-width: 100%;
}
.ready-to-launch .store_brand h6 {
    text-align: center;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    font-weight: 500;
    line-height: 23px;
    margin-top: -20px;
}
.ready-to-launch .right_brand {
    position: absolute;
    right: 0px;
    width: 35px;
    max-height: 40px;
    top: 3px;
}
.ready-to-launch .brand_intro ul li {
    color: #631C3C;
    /* font-family: "Poppins", serif; */
    font-size: 13px;
    margin-bottom: 15px;
    padding-left: 30px;
    position: relative;
    line-height: 16px;
}
.ready-to-launch .brand_desc li:after{
    content: "";
    position: absolute;
    z-index: 1;
    left: 5px;
    width: 20px;
    height: 20px;
    background: url("/../img/check.png");
    background-size: 100%;
}
.campaign-overview-list h4{
    color: #000;
    font-size: 19px;
    font-family: "Roboto", sans-serif;
    margin-top: 20px;
    margin-bottom: 5px;
}
.campaign-overview-list h6{
    color: #000;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
    margin-bottom: 30px;
}
.campaign-overview-list h4 span{
    font-size: 16px;
    font-weight: 400;
}
.ready-to-launch {
    margin-bottom: 30px;
}
.newPrev {
    background: url("/../img/newMobBack.png") !important;
    background-size: 100% !important;
    background-repeat: no-repeat !important;
    height: 630px !important;
    max-width: 305px !important;
    overflow: hidden;
}
.logoHeadBox {
    text-align: center;
    margin-top: 65px;
    display: inline-block;
    width: 100%;
}
.newPrevLogo {
    width: 90px;
    margin: 0 auto;
    background: #fff;
    height: 90px;
    border-radius: 100%;
    padding: 10px;
}
.newPrevHead {
    color: #000;
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 500;
}
.yourVideo {
    width: 90%;
    margin-left: 5%;
    margin-top: 20px;
}
.mediaName{
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
    border-bottom: 1px solid #D5DAD8;
    padding-bottom: 35px;
}
.mediaDesc {
    width: 80%;
    margin-left: 10%;
    margin-top: 20px;
}
.mediaName h4,
.mediaDesc h4{
    font-size: 16px;
    color: #000;
    font-family: "Roboto", sans-serif;
}
.mediaName h6{
    font-weight: normal;
    color: #000;
    font-size: 14px;
    font-family: "Roboto", sans-serif;
}
.mediaDesc p{
    font-size: 13px;
    overflow: hidden;
}
.NewPrevAct .brand_intro {
    min-height: 325px;
    width: 88%;
    float: left;
    margin-left: 6%;
    border-top: 1px solid #B1B5B3;
    padding-top: 4px;
}
.NewPrevAct .brand_header {
    width: 96%;
    margin-left: 2%;
}
.NewPrevAct .brand_header img {
    width: 60px;
    float: left;
    margin-right: 5px;
    border: 1px solid #000;
    padding: 3px;
    min-height: 60px;
}
.mapBox h5{
    color: #000;
    font-size: 15px;
    padding-top: 10px;
}
.mapBox {
    float: left;
    width: 88%;
    margin-left: 6%;
    text-align: center;
    background: #F9FFFC;
    border-top: 1px solid #D5DAD8;
    margin-top: 5px;
}
/* .brand_intro {
    height: 280px;
    background: #FBF0E8;
    width: 82%;
    position: absolute;
    left: 9%;
    top: 266px !important;
} */
.store_brand {
    margin-left: 9%;
    width: 82%;
    padding-top: 50px;
}
.ready-to-launch .brand_header img {
    width: 52px;
    float: left;
    margin-right: 5px;
}
.ready-to-launch .brand_header h6 {
    font-family: "Roboto", sans-serif;
    color: #782B55;
    font-size: 14px;
    margin-left: 5px;
    margin-top: 3px;
    margin-bottom: 5px;
}
.left_brand, .right_brand {
    width: 35px;
    max-height: 40px;
}
.ready-to-launch .task_bar {
    width: 82%;
    position: absolute;
    bottom: 40px;
    left: 9%;
}
.brand_desc p {
    font-size: 13px;
    padding-left: 10px;
    margin-top: 10px;
}
.ready-to-launch .start_pickl {
    position: absolute;
    bottom: 20px;
    margin: 0 auto;
    left: 0;
    right: 0;
    max-width: 100%;
}
.ready-to-launch .store_brand h6 {
    text-align: center;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 500;
    line-height: 23px;
    margin-top: 5px;
    width: 180px;
    float: left;
}
.ready-to-launch .right_brand {
    position: absolute;
    right: 0px;
    width: 35px;
    max-height: 40px;
    top: 3px;
}
.ready-to-launch .brand_intro ul li {
    color: #631C3C;
    font-size: 13px;
    margin-bottom: 15px;
    padding-left: 30px;
    position: relative;
    line-height: 16px;
}
.ready-to-launch .brand_desc li:after{
    content: "";
    position: absolute;
    z-index: 1;
    left: 5px;
    width: 20px;
    height: 20px;
    background: url("/../img/check.png");
    background-size: 100%;
}
.mixTaskList {
    width: 80%;
    margin-left: 10%;
    margin-top: 12px;
    max-height: 160px;
    overflow: hidden;
}
.mixTaskList h4 {
    font-size: 16px;
    color: #000;
    font-family: "Roboto", sans-serif;
    margin-bottom: 8px;
}
.mixTaskList ul {
    list-style: none;
    padding-left: 0px;
    margin: 0;
}
.mixTaskList ul li {
    color: #631C3C;
    font-size: 13px;
    margin-bottom: 8px;
    padding-left: 25px;
    position: relative;
    line-height: 16px;
}
.mixTaskList ul li:after {
    content: "";
    position: absolute;
    z-index: 1;
    left: 0px;
    width: 20px;
    height: 20px;
    background: url("/../img/check.png");
    background-size: 100%;
}
</style>
